import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import StaffPortalPage from '../modules/erp/components/StaffPortalPage';
import { getStaffPortalData, StaffPortalPayload } from '../modules/erp/services/staffPortalService';
import { Loader2, AlertCircle, ArrowLeft } from 'lucide-react';

export default function PublicStaffPortalPage() {
  const { token } = useParams<{ token?: string }>();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<StaffPortalPayload | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    async function loadData() {
      if (!token) {
        setNotFound(true);
        setLoading(false);
        return;
      }

      setLoading(true);
      setNotFound(false);

      try {
        const result = await getStaffPortalData(token);
        if (!isCancelled) {
          if (result) {
            setData(result);
          } else {
            setNotFound(true);
          }
          setLoading(false);
        }
      } catch (err) {
        if (!isCancelled) {
          console.error('Erro ao carregar dados do profissional:', err);
          setNotFound(true);
          setLoading(false);
        }
      }
    }

    loadData();

    return () => {
      isCancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-50 flex flex-col items-center justify-center text-zinc-600 p-4 space-y-4 font-sans">
        <Loader2 className="w-10 h-10 animate-spin text-emerald-600" />
        <div className="text-center">
          <h2 className="text-base font-black text-zinc-900">Carregando sua Agenda...</h2>
          <p className="text-xs text-zinc-500 mt-1">Conectando com o sistema do estabelecimento</p>
        </div>
      </div>
    );
  }

  if (notFound || !data) {
    return (
      <div className="min-h-screen bg-zinc-50 flex flex-col items-center justify-center text-zinc-800 p-6 font-sans">
        <div className="max-w-md w-full bg-white border border-zinc-200 rounded-3xl p-6 text-center space-y-4 shadow-xl">
          <div className="w-14 h-14 rounded-2xl bg-rose-50 text-rose-600 mx-auto flex items-center justify-center border border-rose-100">
            <AlertCircle className="w-7 h-7" />
          </div>
          <div>
            <h2 className="text-lg font-black text-zinc-900">Acesso Não Encontrado</h2>
            <p className="text-xs text-zinc-500 mt-2 leading-relaxed">
              O link de acesso à agenda do profissional não foi encontrado. Solicite ao gestor do salão um novo link de acesso pelo WhatsApp.
            </p>
          </div>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="w-full py-3 bg-zinc-100 hover:bg-zinc-200 text-zinc-800 font-black text-xs rounded-xl border border-zinc-200 transition-all cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Voltar ao Início</span>
          </button>
        </div>
      </div>
    );
  }

  return <StaffPortalPage initialData={data} token={token || 'demo'} />;
}
